import {
  singleTicketClientOptions,
  recurrenceTicketClientOptions,
  coproductionChargeClientOptions,
  infoServiceOptions,
  specialistClientOptions,
  productSellClientOptions,
  partnerPaymentOptions,
  eduzzEliteClientOptions,
  fitCategoryOptions,
} from '@clint-core/commons/src/options';
import Interceptor from '../../core/type/operation/Interceptor';
import {
  projectTypeOptions, companyMomentOptions, expertizeOptions, salesProfileOptions,
} from './options';

const getUrlParams = (url) => {
  const params = {};
  const parser = document.createElement('a');
  parser.href = url;
  const query = parser.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    params[pair[0]] = decodeURIComponent(pair[1]);
  }
  return params;
};

const sortByName = (a, b) => {
  if (a.label < b.label) { return -1; }
  if (a.label > b.label) { return 1; }
  return 0;
};

export default [

  new Interceptor(async (data) => new Promise((resolve) => {
    const params = getUrlParams(window.location.href);
    const options = {
      no_company_options: [{
        value: 'Não tenho empresa',
        text: 'Não tenho empresa',
      }],
      expertize_options: expertizeOptions,
      option_project_type: projectTypeOptions,
      option_your_moment: companyMomentOptions,
      sales_profile_options: salesProfileOptions,
      fit_category_options: fitCategoryOptions,
      sales_product_options: productSellClientOptions,
      option_services: infoServiceOptions,
      recurrence_ticket_options: recurrenceTicketClientOptions,
      eduzz_elite_options: eduzzEliteClientOptions,
      single_ticket_options: singleTicketClientOptions,
      coproduction_charge_options: coproductionChargeClientOptions,
      partner_payment_options: partnerPaymentOptions,
      segment_options: specialistClientOptions.sort(sortByName),
    };
    resolve({
      ...data,
      options,
      type: 'EDUZZ',
      utm_source: params.utm_source,
      utm_medium: params.utm_medium,
      utm_campaign: params.utm_campaign,
    });
  })),
];
